import config from '../../temp/config';
import store from '../../redux/store';
import loadQuoteData from './loadQuoteData';
import requote from './requote';
import validateRetrievedQuote, { RETRIEVAL_OUTCOMES } from './validateRetrievedQuote';
import { setQuoteRevalidation } from '../../redux/slices/appStateSlice';
import { setQuoteResponse } from '../../redux/slices/quoteResponseSlice';

const applyRetrievedQuote = async (data, dispatch) => {
  const result = validateRetrievedQuote(data);

  dispatch(
    setQuoteRevalidation({
      premiumChangeAlert: result.outcome === RETRIEVAL_OUTCOMES.PREMIUM_CHANGED,
      dependantInvalid: result.outcome === RETRIEVAL_OUTCOMES.DEPENDANT_INVALID,
      principalAgeInvalid: result.outcome === RETRIEVAL_OUTCOMES.PRINCIPAL_INVALID,
      invalidDependants: result.invalidDependants || [],
    })
  );

  if (result.outcome === RETRIEVAL_OUTCOMES.PRINCIPAL_INVALID) {
    return result;
  }

  await loadQuoteData(result.data);

  if (result.outcome === RETRIEVAL_OUTCOMES.PREMIUM_CHANGED) {
    const state = store.getState();
    const newQuoteResponse = await requote(state.quoteData, config?.endpoints?.quotes, {
      agentDetails: state.agentDetails,
      utms: state.utms,
    });
    if (newQuoteResponse.shouldPreventSale) {
      result.outcome = RETRIEVAL_OUTCOMES.PREVENT_SALE;
      dispatch(setQuoteResponse(result.data));
    } else {
      dispatch(setQuoteResponse(newQuoteResponse));
    }
  } else {
    dispatch(setQuoteResponse(result.data));
  }

  return result;
};

export default applyRetrievedQuote;
